import React, { useState } from "react";
import { AuthFormData } from "../types/AuthFormData";
import { pageNames } from "../../config/pageNames";

import "./styles/LoginForm.css";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LoaderSm } from "common/components/Loader/Loader";

interface LoginFormProperties {
  onLogin: (formData: AuthFormData) => void;
  isLoading: boolean;
  errorMessage: string;
}

export const LoginForm = ({
  onLogin,
  isLoading,
  errorMessage,
}: LoginFormProperties) => {
  const [formData, setFormData] = useState<AuthFormData>({
    email: "",
    password: "",
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onLogin(formData);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <header className="login-header">
          <Row className="align-items-center">
            <Col xs={12} md={6}>
              <h3 className="login-title">Sign in to your account</h3>
              <p className="login-subtitle">
                Access your dashboard to manage events, actions, and SDG impact.
              </p>
            </Col>
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-md-end justify-content-start mt-2 mt-md-0"
            >
              <div className="login-switch">
                <span className="login-switch__label">New here?</span>
                <Link to={pageNames.REGISTER} className="login-switch__link">
                  Create an account
                </Link>
              </div>
            </Col>
          </Row>
        </header>

        <form onSubmit={handleSubmit} className="login-form">
          {errorMessage && (
            <div className="login-error">
              <p>{errorMessage}</p>
            </div>
          )}

          <div className="login-form__fields">
            <div className="form-group">
              <label htmlFor="email">Work email</label>
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="you@company.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
              />
            </div>
          </div>

          <div className="login-actions">
            <button
              type="submit"
              className={`login-button ${isLoading ? "login-button--loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <LoaderSm /> <span className="ms-2">Signing in...</span>
                </>
              ) : (
                "Sign in"
              )}
            </button>

            <div className="login-forgot">
              <Link to={pageNames.RESET_PWD} className="login-forgot__link">
                Forgot password?
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
